// extracted by mini-css-extract-plugin
export default {"invalidate":"PickupRequestInvalidateButton_invalidate__ufjXq"};